import { xyReduce } from 'ml-spectra-processing';
import { useCallback } from 'react';
import { useChartData } from '../context/ChartContext';
export var XYReducerDomainAxis;
(function (XYReducerDomainAxis) {
    XYReducerDomainAxis["XAxis"] = "XAxis";
    XYReducerDomainAxis["YAxis"] = "YAxis";
})(XYReducerDomainAxis || (XYReducerDomainAxis = {}));
export default function useXYReduce(domainAxis) {
    const { width, xDomain, yDomain } = useChartData();
    return useCallback((data) => {
        const { x, y } = data;
        const [from, to] = domainAxis === XYReducerDomainAxis.XAxis ? xDomain : yDomain;
        return xyReduce({ x, y }, { from, to, nbPoints: width * 4, optimize: true });
    }, [domainAxis, width, xDomain, yDomain]);
}
